
import { Injectable } from '@angular/core';

import { AppConstants } from '../app.constants';
import moment from 'moment';

export enum Month {
  JAN, FEB, MAR, APR, MAY, JUN, JUL, AUG, SEP, OCT, NOV, DEC
}

@Injectable()
export class DateService {

  public static dateTimeFormatString(date: Date): string {
    if (!date) {
      return null;
    }
    return moment(date, moment.ISO_8601).format(AppConstants._dateTimeFormat);
  }

  public static dateFormatString(date: Date): string {
    if (!date) {
      return null;
    }
    return moment(date, moment.ISO_8601).format(AppConstants.dateFormat);
  }

  public static dateToFormattedString(date: Date, format = AppConstants.momentDateFormat): string {
    if (!date) {
      return null;
    }
    return moment(new Date(date), moment.ISO_8601).format(format);
    // return moment(date, moment.ISO_8601).format(format);
  }

  public static dateToFormattedString1(date: Date): string {
    if (!date) {
      return null;
    }
    return moment(date, AppConstants.displayDateFormat).format(AppConstants.momentDateFormat);
  }

  public static yearToFormattedString1(date: Date): string {
    if (!date) {
      return null;
    }
    return moment(date, moment.ISO_8601).format(AppConstants.dateYearFormat);
  }

  public static getUtcYearandMonth(year: number, month: Month): number {
    return +Date.UTC(year, month);
  }

  public static dateTimeToFormattedString(date: Date, format = AppConstants.momentDateTimeFormat): string {
    if (!date) {
      return null;
    }
    return moment(date, moment.ISO_8601).format(format);
  }

  public static getUtcInstance(year: number, month: Month, date: number): number {
    return +Date.UTC(year, month, date);
  }

  public static getUtcInstanceFromDate(input: Date): number {
    if (!input) {
      return null;
    }
    // return +Date.UTC(input.getFullYear(), input.getMonth(), input.getDate());
    return +moment(input, moment.ISO_8601).format('x');
  }

  public static _getUtcInstanceFromDateTime(input: Date): number {
    console.log('input date service', input);
    if (!input) {
      return null;
    }
    return +moment(input, moment.ISO_8601).format('x');
    // return +Date.UTC(input.getFullYear(), input.getMonth(), input.getDate(), input.getHours(), input.getMinutes(), input.getSeconds());
  }

  public static getUtcInstanceFromDateTime(year: number, month: Month, date: number, hour: number, minute: number): number {
    return +Date.UTC(year, month, date, hour, minute);
  }

  public static getUtcInstanceFromDateAndTime(input: Date, hour: number, minute: number): number {
    return +Date.UTC(input.getFullYear(), input.getMonth(), input.getDate(), hour, minute);
  }
  public static stringToDateConverter(date: string, format = 'DD-MM-YYYY'): Date {
    return moment(date, format).toDate();
  }
  public static isBefore(largerDate: Date, smallerDate: Date): boolean {

    return moment(smallerDate).isBefore(largerDate);

  }
  public static isAfter(fromDate: Date, toDate: Date): boolean {

    return moment(fromDate).isAfter(toDate);

  }
  public static isSame(fromDate: Date, toDate: Date): boolean {

    return moment(toDate).isSame(fromDate, 'd');

  }
  public static isSameOrAfter(fromDate: Date, toDate: Date): boolean {
    // console.log(moment(fromDate).isSameOrAfter(toDate, 'd'));
    // console.log(new Date(fromDate), new Date(toDate));

    return moment(fromDate).isSameOrAfter(toDate, 'd');

  }
}
